/* 🤖 this file was generated by svg-to-ts */
export const matIconDeleteSweep: {
  name: 'delete-sweep';
  data: string;
} = {
  name: 'delete-sweep',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M15 16h4v2h-4zm0-8h7v2h-7zm0 4h6v2h-6zM3 18c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V8H3v10zm2-8h6v8H5v-8zm5-6H6L5 5H2v2h12V5h-3z"/></svg>`
};
